import { getToken } from 'firebase/messaging';
import { getFirebaseMessaging } from './firebaseConfig';
import { apiUrl, apiHeaders } from './api';

const VAPID_KEY =
  'BMDBsM2Q65b2gTlnUj2vm0xMDr0aYumU3SaS6olCxkWOGd38gXK4BMJkCP8Uhcd6cyOi54N27ug_YKic5Pld7u4';

export type PushRegisterResult =
  | { status: 'registered'; token: string }
  | { status: 'denied' }
  | { status: 'unsupported' }
  | { status: 'failed' };

export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    console.warn('[push] Notifications not supported in this environment');
    return 'denied';
  }

  if (Notification.permission === 'default') {
    return await Notification.requestPermission();
  }

  return Notification.permission;
}

export async function registerWebPushToken(
  authToken: string
): Promise<PushRegisterResult> {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return { status: 'unsupported' };
  }

  const permission = await requestNotificationPermission();
  if (permission !== 'granted') {
    console.warn('[push] Notification permission not granted');
    return { status: 'denied' };
  }

  const messaging = await getFirebaseMessaging();
  if (!messaging) {
    return { status: 'failed' };
  }

  if (!VAPID_KEY) {
    console.warn('[push] Missing VITE_FIREBASE_VAPID_KEY');
    return { status: 'failed' };
  }

  try {
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    if (!token) {
      console.warn('[push] Failed to obtain FCM token');
      return { status: 'failed' };
    }

    await fetch(apiUrl('/api/push/register'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...apiHeaders(authToken),
      },
      body: JSON.stringify({
        token,
        platform: 'WEB',
      }),
    });

    return { status: 'registered', token };
  } catch (err) {
    console.warn('[push] register failed', err);
    return { status: 'failed' };
  }
}
